import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import { ASSET_CLASS_URL, ASSET_TYPE_URL, ASSET_TYPE_DOWNLOAD_URL } from "../../Constants/Constants";
import AxiosInstance from "../../services/AxiosInstance";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import AddTaskIcon from "@mui/icons-material/AddTask";
import SaveIcon from "@mui/icons-material/Save";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { useAlert } from "./../alerts/AlertContext";
import { Link } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { isEmpty } from "../../Constants/RolesConstants";

function AssetTypeDialog({
  assetTypeId,
  selectedTypeName,
  callAssetTypes,
  actionType,
  isEdit,
  componentPermissions = {},
}) {
  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const [open, setOpen] = React.useState(false);
  const [typeName, setTypeName] = useState("");
  const [desc, setDesc] = useState("");
  const [file, setFile] = useState([]);
  const [status, setStatus] = useState(true);
  const [assetClass, setAssetClass] = useState();
  const [assetClasses, setAssetClasses] = useState([]);
  const showAlert = useAlert();

  const [fileName, setFileName] = useState();
  const [extension, setExtension] = useState();

  useEffect(() => {
    getAssetClasses();
  }, []);

  const handleClickOpen = () => {
    if (isEdit === true) {
      getAssetType();
    } else {
      setOpen(true);
    }
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleAssetTypeNameChange = (event) => {
    setTypeName(event.target.value);
  };

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleDescriptionChange = (event) => {
    setDesc(event.target.value);
  };

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  const getAssetClasses = () => {
    AxiosInstance.get(ASSET_CLASS_URL).then((response) =>
      setAssetClasses(response.data.data)
    );
  };

  const handleAssetClassChange = (event) => {
    setAssetClass(event.target.value);
  };

  const getAssetType = () => {
    // TODO: server side pagination isn't implemented in server yet, so this will be currently client side pagination
    AxiosInstance.get(`${ASSET_TYPE_URL}/${assetTypeId}`).then((response) => {
      //setData(response.data)
      var typeData = response.data.data;
      setAssetClass(typeData.assetClass.id);
      setTypeName(typeData.name);
      setDesc(typeData.description);
      setStatus(typeData.status);
      setFileName(typeData.fileName);
      setExtension(typeData.extension);
      setOpen(true);
    }
    )
  };

  const handleSave = () => {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("name", typeName);
    formData.append("assetClassId", assetClass);
    formData.append("description", desc);
    formData.append("status", status);

    if (isEdit) {
      updateAsseType(formData);
    } else {
      saveAsseType(formData);
    }
  };

  const saveAsseType = async (formData) => {
    await AxiosInstance.post(ASSET_TYPE_URL, formData)
      .then((response) => {
        showAlert("Asset Type created successfully!", "success");
        callAssetTypes();
      })
      .catch((error) => {
        showAlert("Asset Type creation failed!", "error");
        console.error(error);
      });
  };

  const updateAsseType = async (formData) => {
    await AxiosInstance.put(`${ASSET_TYPE_URL}/${assetTypeId}`, formData)
      .then((response) => {
        showAlert("Asset Type updated successfully!", "success");
        callAssetTypes();
      })
      .catch((error) => {
        showAlert("Asset Type updation failed!", "error");
        console.error(error);
      });
  };

  const handleDownload = async (attachId, attachFileName, fileExt) => {
    try {
      const response = await AxiosInstance.get(`${ASSET_TYPE_DOWNLOAD_URL}/${attachId}`, {
        responseType: "blob",
      });

      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: fileExt })
      );

      const alink = document.createElement("a");
      alink.href = fileURL;
      alink.setAttribute("download", attachFileName);
      document.body.appendChild(alink);
      alink.click();
      alink.parentNode.removeChild(alink);

    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const saveButtonSx = {
    float: "right",
    minWidth: 150,
    marginRight: "25px",
    marginTop: "10px",
    background: "linear-gradient(45deg, #1976d2 30%, #42a5f5 90%)",
    boxShadow: "0 3px 5px 2px rgba(25, 118, 210, .3)",
    "&:hover": {
      background: "linear-gradient(45deg, #1565c0 30%, #1976d2 90%)",
    },
  };

  return (
    <ThemeProvider>
      <React.Fragment>
        {/* <Button
          variant="outlined"
          onClick={handleClickOpen}
          style={{ float: "right", margin: "5px 0px" }}
        >
          Add Asset Type
        </Button> */}
        {assetTypeId === 0 ? (
          <Tooltip
            title="Add Asset Type"
            onClick={handleClickOpen}
            style={{ cursor: "pointer", margin: "2px", float: "right" }}
          >
            <IconButton>
              <AddTaskIcon color="primary" />
            </IconButton>
          </Tooltip>
        ) : (
            <Link onClick={handleClickOpen}>{selectedTypeName}</Link>
          )}
        <Dialog
          open={open}
          onClose={handleClose}
          PaperProps={{
            component: "form",
            onSubmit: (event) => {
              event.preventDefault();
              (isEmpty(componentPermissions) ||
                componentPermissions?.["canUpdate"] ||
                componentPermissions?.["canCreate"]) &&
                handleSave();
              handleClose();
            },
            sx: {
              width: 600,
              height: 540,
              maxWidth: "100%",
              maxHeight: "100%",
            },
          }}
        >
          <DialogTitle>{actionType} Asset Type</DialogTitle>
          <DialogContent>
            <Box
              component="form"
              noValidate
              autoComplete="off"
              sx={{ "& .MuiTextField-root": { m: 1, width: "95%" } }}
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="rg"
                name="name"
                label="Asset Type Name"
                type="text"
                fullWidth
                variant="outlined"
                value={typeName}
                onChange={handleAssetTypeNameChange}
              />
              <br />
              <TextField
                autoFocus
                id="outlined-multiline-static"
                name="description"
                label="Description"
                placeholder="Enter Description"
                fullWidth
                multiline
                rows={4}
                cols={10}
                value={desc}
                onChange={handleDescriptionChange}
              />
              <br />
              <FormControl variant="outlined" sx={{ m: 1, minWidth: 250 }}>
                <InputLabel id="asset-type-class-label">
                  Asset Class
                </InputLabel>
                <Select
                  labelId="asset-type-class-label"
                  id="asset-type-class-select"
                  value={assetClass}
                  onChange={handleAssetClassChange}
                  label="Asset Class"
                >
                  <MenuItem value="">
                    {" "}
                    <em>None </em>{" "}
                  </MenuItem>
                  {assetClasses.map((ac) => (
                    <MenuItem value={ac.id}>{ac.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ m: 1, minWidth: "47%" }}>
                <FormLabel id="asset-type-status-label">
                  Status
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="asset-type-status-label"
                  name="row-radio-buttons-group"
                  value={status}
                  onChange={handleStatusChange}
                >
                  <FormControlLabel
                    value={true}
                    control={<Radio />}
                    label="Active"
                  />
                  <FormControlLabel
                    value={false}
                    control={<Radio />}
                    label="In-Active"
                  />
                </RadioGroup>
              </FormControl>
              <br />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, m:1 }}>
              <Button
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
              >
                Upload files
                <VisuallyHiddenInput type="file" onChange={handleFileChange} />
              </Button>
              {assetTypeId !== 0 && fileName != null && fileName != "" &&
              <>
                <br /> <br />
                <Link
                  underline="hover"
                  color="primary"
                  onClick={() => handleDownload(assetTypeId, fileName, extension)}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <DownloadIcon fontSize="small" />
                  {fileName}
                </Link>
              </>
              }
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ marginBottom: "20px" }}>
            {actionType === "Add" ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
            {actionType === "Edit" &&
            (isEmpty(componentPermissions) ||
              componentPermissions?.["canUpdate"]) ? (
              <Button
                variant="contained"
                type="submit"
                startIcon={<SaveIcon />}
                sx={saveButtonSx}
              >
                Save
              </Button>
            ) : null}
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
export default AssetTypeDialog;
